<template>
  <section class="level pt-3 pb-20">
    <div class="level-left"></div>
    <div class="level-right">
      <div class="level-item is-size-7 has-text-default">
        {{$t('general.perPageResult')}}
      </div>
      <div class="level-item">
        <b-select
          v-model="perPageValue"
          @input="$emit('page-change', 1)"
          placeholder="10"
          class="is-primary">
          <option
            v-for="value in perPageList"
            :key="value"
            :value="value">
            {{value}}
          </option>
        </b-select>
      </div>
      <div class="level-item">
        <b-pagination
          :total="total"
          :current="page"
          :per-page="perPageValue"
          @change="$emit('page-change', $event)"
          order="is-centered">
        </b-pagination>
      </div>
    </div>
  </section>
</template>
<script>
import { PER_PAGE_LIST } from '@/configuration/tableConfig';

export default {
  props: {
    page: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      perPageList: PER_PAGE_LIST,
    };
  },
  computed: {
    perPageValue: {
      get() {
        return this.perPage;
      },
      set(val) {
        this.$emit('perPage-change', val);
      },
    },
  },
};
</script>
